var render = function(_h, _vm) {
  var _c = _vm._c
  return _c(
    "svg",
    _vm._g(
      _vm._b(
        {
          ref: _vm.data.ref,
          class: [_vm.data.class, _vm.data.staticClass],
          style: [_vm.data.style, _vm.data.staticStyle],
          attrs: {
            width: "21",
            height: "20",
            viewBox: "0 0 21 20",
            xmlns: "http://www.w3.org/2000/svg"
          }
        },
        "svg",
        _vm.data.attrs,
        false
      ),
      _vm.listeners
    ),
    [
      _c("path", {
        attrs: {
          d:
            "M10.4208 20C8.90881 20.0043 7.41597 19.6622 6.05675 19C5.5593 18.758 5.08268 18.4754 4.63175 18.155L4.49475 18.055C3.25457 17.1396 2.24063 15.9522 1.53075 14.584C0.79649 13.1679 0.415662 11.5952 0.420704 10C0.420704 4.47715 4.89791 0 10.4208 0C15.9436 0 20.4208 4.47715 20.4208 10C20.4258 11.5944 20.0453 13.1664 19.3118 14.582C18.6029 15.9494 17.5903 17.1364 16.3518 18.052C15.8845 18.394 15.3887 18.6951 14.8698 18.952L14.7898 18.992C13.4297 19.6577 11.935 20.0026 10.4208 20ZM10.4208 15C8.92223 14.9971 7.54842 15.834 6.86375 17.167C9.10515 18.2772 11.7364 18.2772 13.9778 17.167V17.162C13.2922 15.8305 11.9184 14.9954 10.4208 15ZM10.4208 13C12.5869 13.0028 14.5842 14.1701 15.6498 16.056L15.6648 16.043L15.6788 16.031L15.6618 16.046L15.6518 16.054C18.1808 13.8691 19.085 10.3423 17.9194 7.21011C16.7538 4.07788 13.7638 2.00032 10.4218 2.00032C7.07966 2.00032 4.08975 4.07788 2.92411 7.21011C1.75846 10.3423 2.66276 13.8691 5.19175 16.054C6.25801 14.169 8.25512 13.0026 10.4208 13ZM10.4208 12C8.21162 12 6.42075 10.2091 6.42075 8C6.42075 5.79086 8.21162 4 10.4208 4C12.6299 4 14.4208 5.79086 14.4208 8C14.4208 9.06087 13.9993 10.0783 13.2492 10.8284C12.499 11.5786 11.4816 12 10.4208 12ZM10.4208 6C9.31618 6 8.42075 6.89543 8.42075 8C8.42075 9.10457 9.31618 10 10.4208 10C11.5253 10 12.4208 9.10457 12.4208 8C12.4208 6.89543 11.5253 6 10.4208 6Z"
        }
      })
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }